/**
 * Imports
*/
import Masonry from 'react-masonry-component';


// utils
import lang from '../../misc/i18n.js';
import InstabergUtils from '../../misc/utils.js';

/**
 * WordPress dependencies
*/
const { __, _n, sprintf } = wp.i18n;
const { Component, render, findDOMNode, Fragment } = wp.element;

/**
 * Config
*/
const localizationName = 'instaberg';
const alias = 'AAInstaberg-View-';



/**
 * React Components
*/
class InstabergViewClassic_ListItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isHovered: false,
      isHoveredLink: { 0: false, 1: false },
    };
  }

  render()
  {
    let { isHovered, isHoveredLink } = this.state;
    const { video } = this.props;
    let { image, total_comments, total_likes, caption, link, post_type, username, user_pic } = video;

    const styleGridImg = {
      backgroundImage: `url(${image})`,
    };
    
    caption = InstabergUtils.text_truncate( caption, 100);

    total_likes = 'undefined' === typeof total_likes ? 0 : total_likes;
    total_likes = InstabergUtils.humanFormat( total_likes );

    total_comments = 'undefined' === typeof total_comments ? 0 : total_comments;
    total_comments = InstabergUtils.humanFormat( total_comments );
    
    return (
      <div
        className={ `${alias}element` }
        data-key={ video.id }
        onClick={ (e) => { this.handleMenuClick( e, { videoid: video.id, image, post_type } ) } }
      >
        <div className={ `${alias}username-header` }>
          <div className={ `${alias}avatar-container` }>
            <a href={`https://www.instagram.com/${username}`}><img src={user_pic} alt={username} /> </a>
          </div>
          <div className={ `${alias}header-text` }>
            <a href={`https://www.instagram.com/${username}`}>{ username } </a>
          </div>
          <div className={ `${alias}header-btn` }>
            <a href={`https://www.instagram.com/${username}`}>View Profile </a>
          </div>
        </div>
        <a href={ link } className={ `classic-img-url` }>
          <span className={ `${alias}img` }>
            { '' !== image ? <img src={ image } /> : '' }
            { InstabergUtils.itemShowIcon( post_type ) }
          </span>
        </a>

        <div className={ `${alias}classic-description` }>
          <div className={ `${alias}description-view-more` }>
            <a href={`https://www.instagram.com/${username}`}>View More On Instagram </a>
          </div>
          <div className={ `${alias}classic-misc` }>

            <span className={ `${alias}misc-likes` }>
              <a href={ link } target="_blank"
                style={ isHoveredLink[0] ? { color: this.props.pcstyle.mainColor, fontFamily: this.props.pcstyle.fontFamily } : {fontFamily: this.props.pcstyle.fontFamily} }
                onMouseEnter={ (e) => { this.handleMenuHoverLink( e, 0 ) } }
                onMouseLeave={ (e) => { this.handleMenuHoverLink( e, 0 ) } }
              >
                <i className="mi-icon mi-icon-heart4" style={ { color: this.props.pcstyle.mainColor } }></i>{ total_likes }
              </a>
            </span>
            <span className={ `${alias}misc-comments` }>
              <a href={ link } target="_blank"
                style={ isHoveredLink[1] ? { color: this.props.pcstyle.mainColor, fontFamily: this.props.pcstyle.fontFamily } : {fontFamily: this.props.pcstyle.fontFamily} }
                onMouseEnter={ (e) => { this.handleMenuHoverLink( e, 1 ) } }
                onMouseLeave={ (e) => { this.handleMenuHoverLink( e, 1 ) } }
              >
                <i className="mi-icon mi-icon-bubble2" style={ { color: this.props.pcstyle.mainColor } }></i>{ total_comments }
              </a>
            </span>

          </div>

    {/*      <div className={ `${alias}classic-info` }>
            <p style={{
              color: this.props.pcstyle.color,
              fontSize: this.props.pcstyle.fontSize,
              fontFamily: this.props.pcstyle.fontFamily
            }}>{ caption }</p>
          </div>
*/}
        </div>

      </div>
    );
  }

  handleMenuHover( event )
  {
    this.setState({
      isHovered: ! this.state.isHovered
    });
  }

  handleMenuClick( event, pms )
  {
    event.preventDefault();
    this.props.onClickListItem( pms );
  }

  handleMenuHoverLink( event, thekey )
  {
    let { isHoveredLink } = this.state;

    let newval = ! isHoveredLink[ thekey ];
    this.setState({
      isHoveredLink: { ...isHoveredLink, [thekey] : newval }
    });
  }
}

class InstabergViewClassic extends Component {

  constructor(props) {
    super(props);
  }

  render()
  {
    return ( this.PrintVideosList() );
  }

  PrintVideoSingleElement( video )
  {
    let pcstyle = {
      color: this._get_option('primaryColor')['text_color'],
      mainColor: this._get_option('primaryColor')['main_color'],
      fontSize: this._get_option('primaryColor')['font_size'],
      fontFamily: this._get_option('primaryColor')['font_family']

    };

    return (
      <InstabergViewClassic_ListItem
        pcstyle={ pcstyle }
        video={ video }
        onClickListItem={ (pms) => { this.props.onClickListItem( pms ) } }
      />
    );
  }

  PrintVideosList()
  {
    const { layoutType } = this.props.options;
    let { videos } = this.props;
    const masGridCols = parseInt( this._get_option('masGridCols') );
    if ( ! videos.length ) {
      return '';
    }

    const video_list = videos.map( video => {
      return ( this.PrintVideoSingleElement( video ) );
    });

    const masonryOptions = {
      transitionDuration: 0,
      itemSelector: `.${alias}element`,
      columnWidth: `.${alias}element-sizer`,
      gutter: 'backend' === this.props.where ? 36 : 48,
      percentPosition: true,
    };
    const imagesLoadedOptions = {
    };

    return (
      <React.Fragment>
        <Masonry
          className={ `${alias}classic-grid ${alias}classic-${masGridCols}col` } // default ''
          elementType={ 'div' } // default 'div'
          options={ masonryOptions } // default {}
          disableImagesLoaded={ false } // default false
          updateOnEachImageLoad={ false } // default false and works only if disableImagesLoaded is false
          imagesLoadedOptions={ imagesLoadedOptions } // default {}
        >
          <div className={ `${alias}element-sizer` }></div>
          { video_list }
        </Masonry>
      </React.Fragment>
    );
  }

  //============================================================================================
  // MISC
  _get_option( opt_name )
  {
    let options = this.props.options;

    let opt = null;
    if ( InstabergUtils.isset( options, opt_name ) ) {
      opt = options[ opt_name ];
    }
    return opt;
  }

}
export { InstabergViewClassic };



// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/templates/classic/tpl.view.js